/* eslint-disable camelcase */
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { withTranslation } from 'config/i18n';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import AddPayoutMethodDialog from 'components/ownerPages/earningsAndPayouts/payoutMethodSettings/AddPayoutMethodDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1.5),
  },
  title: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(21),
    },
  },
  subtitle: {
    fontWeight: 600,
  },
  description: {
    fontSize: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(1),
  },
  button: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
  },
  bankAccounts: {
    marginTop: theme.spacing(2),
    '& $banksLabel': {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.grey[300],
    },
    '& $bankName': {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  banksLabel: {},
  bankName: {},
}));

const PayoutMethodSettings = ({ t, transferMethods, refreshPageData }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false); // payout withdraw dialog

  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.title}>
        {t('fe_earnings_and_payouts_page:payout_method_settings.title')}
      </Typography>
      <Typography variant="h5" className={classes.subtitle}>
        {t('fe_earnings_and_payouts_page:payout_method_settings.subtitle')}
      </Typography>
      <Typography variant="h5" className={classes.description}>
        {t('fe_earnings_and_payouts_page:payout_method_settings.description')}
      </Typography>
      <Button variant="outlined" onClick={() => setOpen(true)} color="default" className={classes.button}>
        {t('fe_earnings_and_payouts_page:payout_method_settings.add_payout_method')}
      </Button>
      {
          open && (
            <AddPayoutMethodDialog
              open={open}
              onClose={(success) => {
                setOpen(false);
                if (success) {
                  refreshPageData();
                }
              }}
            />
          )
        }
      {
          transferMethods?.bank_accounts && (
            <div className={classes.bankAccounts}>
              <Typography className={classes.banksLabel}>{t('fe_earnings_and_payouts_page:payout_method_settings.bank_accounts')}</Typography>
              <ul>
                {
                transferMethods.bank_accounts.map((bankAccount) => {
                  const { created_at } = bankAccount;
                  return (
                    <li className={classes.bankName} key={`${bankAccount.account_id}`}>
                      {bankAccount.bank_name}
                      {' '}
  &nbsp;
                      { bankAccount.account_id && (<b>{`(${bankAccount.account_id})`}</b>) }
                      { created_at && (
                        ` - Created on ${dayjs(created_at.time).format('MMM D,YYYY')} at ${dayjs(created_at.time).format('hh:mm A ')} ${created_at.time_zone}`
                      )}
                    </li>
                  );
                })
              }
              </ul>
            </div>
          )
        }
    </div>
  );
};

export default withTranslation(['fe_earnings_and_payouts_page'])(PayoutMethodSettings);
